import { useNavigationContext } from '../../../contexts/NavigationContext';
import MainLayout from '../../../components/Display/MainLayout';
import EventPage from './Events/EventPage';
import './Kerbouzier.scss';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (

    <MainLayout enableAnalytics={false} scope={'kerbouzier'} websiteLabel={"kerbouzier.fr"}>
      <EventPage isActive={navigationContext.activeAppKey === 'kbevent'} />
    </MainLayout>
  );
}

export default Home;
